export const VALUES_FIELD_NAME = [
    'EN',
    'AA',
    'AB',
    'AD',
    'AE',
    'AF',
    'AK',
    'AM',
    'AN',
    'AR',
    'AS',
    'ASL',
    'AV',
    'AY',
    'AZ',
    'BA',
    'BE',
    'BG',
    'BH',
    'BI',
    'BM',
    'BN',
    'BO',
    'BR',
    'BS',
    'BSL',
    'CA',
    'CE',
    'CH',
    'CO',
    'CR',
    'CS',
    'CU',
    'CV',
    'CY',
    'DA',
    'DE',
    'DV',
    'DZ',
    'EE',
    'EL',
    'EO',
    'ES',
    'ET',
    'EU',
    'FA',
    'FF',
    'FI',
    'FJ',
    'FO',
    'FR',
    'FY',
    'GA',
    'GD',
    'GL',
    'GN',
    'GU',
    'GV',
    'HA',
    'HE',
    'HI',
    'HO',
    'HR',
    'HT',
    'HU',
    'HY',
    'HZ',
    'IA',
    'ID',
    'IE',
    'IG',
    'II',
    'IK',
    'INSL',
    'IO',
    'IS',
    'ISE',
    'ISG',
    'IT',
    'IU',
    'JA',
    'JV',
    'KA',
    'KG',
    'KI',
    'KJ',
    'KK',
    'KL',
    'KM',
    'KN',
    'KO',
    'KR',
    'KS',
    'KU',
    'KV',
    'KW',
    'KY',
    'LA',
    'LB',
    'LG',
    'LI',
    'LN',
    'LO',
    'LT',
    'LU',
    'LV',
    'MG',
    'MH',
    'MI',
    'MK',
    'ML',
    'MN',
    'MR',
    'MS',
    'MT',
    'MY',
    'NA',
    'NB',
    'ND',
    'NE',
    'NG',
    'NL',
    'NN',
    'NO',
    'NR',
    'NV',
    'NY',
    'OC',
    'OJ',
    'OM',
    'OR',
    'OS',
    'PA',
    'PI',
    'PL',
    'PS',
    'PT',
    'PT-BR',
    'QU',
    'RM',
    'RN',
    'RO',
    'RU',
    'RW',
    'SA',
    'SC',
    'SD',
    'SE',
    'SG',
    'SI',
    'SIEN',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SQ',
    'SR',
    'SS',
    'SSP',
    'ST',
    'SU',
    'SV',
    'SW',
    'TA',
    'TE',
    'TG',
    'TH',
    'TI',
    'TK',
    'TL',
    'TN',
    'TO',
    'TR',
    'TS',
    'TT',
    'TW',
    'TY',
    'UG',
    'UK',
    'UR',
    'UZ',
    'VE',
    'VI',
    'VO',
    'WA',
    'WO',
    'XH',
    'YI',
    'YO',
    'YUE',
    'ZA',
    'ZH',
    'ZU',
] as const;
export type TYPES_FIELD_NAME = typeof VALUES_FIELD_NAME[number];

export const VALUES_FIELD_LOCALIZEDNAME = [
    'English',
    'Afaraf',
    'аҧсуа бызшәа, аҧсшәа',
    'Access Tours',
    'avesta',
    'Afrikaans',
    'Akan',
    'አማርኛ',
    'aragonés',
    'العربية',
    'অসমীয়া',
    'American Sign Language',
    'авар мацӀ, магӀарул мацӀ',
    'aymar aru',
    'azərbaycan dili',
    'башҡорт теле',
    'беларуская мова',
    'български език',
    'भोजपुरी',
    'Bislama',
    'bamanankan',
    'বাংলা',
    'བོད་ཡིག',
    'brezhoneg',
    'bosanski jezik',
    'BSL',
    'Catalan',
    'нохчийн мотт',
    'Chamoru',
    'corsu, lingua corsa',
    'ᓀᐦᐃᔭᐍᐏᐣ',
    'Ceský jazyk',
    'ѩзыкъ словѣньскъ',
    'чӑваш чӗлхи',
    'Cymraeg',
    'Dansk',
    'Deutsch',
    'ދިވެހި',
    'རྫོང་ཁ',
    'E?egbe',
    'Hellenic',
    'Esperanto',
    'Español',
    'eesti, eesti keel',
    'euskara, euskera',
    'فارسی',
    'Fulfulde, Pulaar, Pular',
    'Finnish',
    'vosa Vakaviti',
    'føroyskt',
    'Français',
    'Frysk',
    'Gaeilge',
    'Gàidhlig',
    'Galego',
    "Avañe'ẽ",
    'ગુજરાતી',
    'Gaelg, Gailck',
    'هَوُسَ',
    'עברית',
    'हिन्दी, हिंदी',
    'Hiri Motu',
    'Hrvatski jezik',
    'Kreyòl ayisyen',
    'magyar',
    'Հայերեն',
    'Otjiherero',
    'Interlingua',
    'Bahasa Indonesia',
    'Originally called Occidental; then Interlingue after WWII',
    'Asụsụ Igbo',
    'ꆈꌠ꒿ Nuosuhxop',
    'Iñupiaq, Iñupiatun',
    'International Sign Language',
    'Ido',
    'Íslenska',
    'Italian Sign Language',
    'Irish Sign Language',
    'Italiano',
    'ᐃᓄᒃᑎᑐᑦ',
    '日本語',
    'ꦧꦱꦗꦮ',
    'ქართული',
    'Kikongo',
    'Gĩkũyũ',
    'Kuanyama',
    'қазақ тілі',
    'kalaallisut',
    'ខ្មែរ, ខេមរភាសា, ភាសាខ្មែរ',
    'ಕನ್ನಡ',
    '한국어',
    'Kanuri',
    'कश्मीरी, كشميري‎',
    'Kurdî, کوردی‎',
    'коми кыв',
    'Kernewek',
    'Кыргызча, Кыргыз тили',
    'latine, lingua latina',
    'Lëtzebuergesch',
    'Luganda',
    'Limburgs',
    'Lingála',
    'ພາສາລາວ',
    'Lietuviu kalba',
    'Kiluba',
    'Latviešu valoda',
    'fiteny malagasy',
    'Kajin M̧ajeļ',
    'te reo Maori',
    'македонски јазик',
    'മലയാളം',
    'Монгол хэл',
    'मराठी',
    'Bahasa Melayu, بهاس ملايو‎',
    'Malti',
    'ဗမာစာ',
    'Dorerin Naoero',
    'Norsk Bokmål',
    'isiNdebele',
    'Nepali',
    'Owambo',
    'Nederlands',
    'Norsk Nynorsk',
    'Norsk',
    'isiNdebele',
    'Diné bizaad',
    'chiCheŵa, chinyanja',
    "occitan, lenga d'òc",
    'ᐊᓂᔑᓈᐯᒧᐎᓐ',
    'Afaan Oromoo',
    'ଓଡ଼ିଆ',
    'ирон æвзаг',
    'ਪੰਜਾਬੀ',
    'पाऴि',
    'Jezyk polski',
    'پښتو',
    'Português',
    'Português do Brasil',
    'Runa Simi, Kichwa',
    'Rumantsch grischun',
    'Ikirundi',
    'Română',
    'Русский',
    'Ikinyarwanda',
    'संस्कृतम्',
    'sardu',
    'सिन्धी, سنڌي، سندھی‎',
    'Davvisámegiella',
    'yângâ tî sängö',
    'සිංහල',
    'Simplified English',
    'Slovencina',
    'Slovenski Jezik, Slovenščina',
    "gagana fa'a Samoa",
    'chiShona',
    'Soomaaliga, af Soomaali',
    'Shqip',
    'српски језик',
    'SiSwati',
    'Spanish Sign Language',
    'Sesotho',
    'Basa Sunda',
    'Svenska',
    'Kiswahili',
    'தமிழ்',
    'తెలుగు',
    'тоҷикӣ, toçikī, تاجیکی‎',
    'ไทย',
    'ትግርኛ',
    'Türkmen, Түркмен',
    'Wikang Tagalog',
    'Setswana',
    'Faka Tonga',
    'Türkçe',
    'Xitsonga',
    'татар теле, tatar tele',
    'Twi',
    'Reo Tahiti',
    'ئۇيغۇرچە‎, Uyghurche',
    'Ukrainian',
    'اردو',
    'Oʻzbek, Ўзбек, أۇزبېك‎',
    'Tshiven?a',
    'Tiếng Việt',
    'Volapük',
    'Walon',
    'Wollof',
    'isiXhosa',
    'ייִדיש',
    'Yorùbá',
    '粵語',
    'Saɯ cueŋƅ, Saw cuengh',
    '中文',
    'isiZulu',
] as const;
export type TYPES_FIELD_LOCALIZEDNAME = typeof VALUES_FIELD_LOCALIZEDNAME[number];
